"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = void 0;
const types_1 = require("@fluent-forever/types");
const zod_1 = require("zod");
/**
 * Given an exception typed as unknown, returns the most likely
 * error message.
 *
 * Inspired by:
 * https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
 */
const getErrorMessage = (error) => toErrorWithMessage(error).message;
exports.getErrorMessage = getErrorMessage;
// === INTERNAL ===
const ErrorWithMessageSchema = zod_1.z.object({
    message: zod_1.z.string(),
});
const isErrorWithMessage = types_1.getTypeValidationFunction(ErrorWithMessageSchema);
const toErrorWithMessage = (error) => {
    if (isErrorWithMessage(error))
        return error;
    try {
        return new Error(JSON.stringify(error));
    }
    catch (e) {
        // Fallback in case there's an error stringifying error
        // (e.g.: circular references...).
        return new Error(String(error));
    }
};
//# sourceMappingURL=error_utils.js.map